import { render, staticRenderFns } from "./RestoreAndBackupDb.vue?vue&type=template&id=0a80c292"
import script from "./RestoreAndBackupDb.vue?vue&type=script&lang=js"
export * from "./RestoreAndBackupDb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports